import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const SetLupaPassword = () => {
  const location = useLocation();
  const phonenumber = location.state?.phonenumber || '';
  const otp = location.state?.otp || '';

const navigate = useNavigate();
  
  const [nama, setNama] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError('Password dan Konfirmasi Password tidak cocok');
      return;
    }

    try {
      // Kirim data biodata ke backend untuk diproses
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/users/gantipassword`, { phonenumber, password, otp });
      setSuccessMessage(response.data.message);
      setError('');
      navigate('/login', { state: { phonenumber } });

    } catch (error) {
      setError(error.response?.data?.message || 'Terjadi kesalahan saat menyimpan biodata');
      setSuccessMessage('');
    }
  };

  return (
    <div>
      <div className="auth-main">
        <div className="auth-wrapper v3">
          <div className="auth-form">
            <div className="card my-5">
              <div className="card-body">
                <a href="#" className="d-flex justify-content-center">
                  <img src="/assets/images/logogvfix.png" width={150} alt="image" className="img-fluid brand-logo" />
                </a>
                <div className="row">
                  <div className="d-flex justify-content-center">
                    <div className="auth-header">
                      <h2 className="text-secondary mt-5"><b>Ganti Password baru</b></h2>
                      <p className="f-16 mt-2">masukkan Password Baru Kamu</p>
                    </div>
                  </div>
                </div>
                <form onSubmit={handleSubmit}>
                  
                  <div className="form-floating mb-3">
                    <input 
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)} 
                      className="form-control" 
                      id="floatingPassword" 
                      placeholder="Password" 
                    />
                    <label htmlFor="floatingPassword">Password</label>
                  </div>
                  <div className="form-floating mb-3">
                    <input 
                      type="password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)} 
                      className="form-control" 
                      id="floatingConfirmPassword" 
                      placeholder="Konfirmasi Password" 
                    />
                    <label htmlFor="floatingConfirmPassword">Konfirmasi Password</label>
                  </div>
                  <div className="d-grid mt-4">
                    <button type="submit" className="btn btn-secondary">Simpan Password Baru</button>
                  </div>
                </form>

                {error && <div className="alert alert-danger mt-2">{error}</div>}
                {successMessage && <div className="alert alert-success mt-2">{successMessage}</div>}

                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetLupaPassword;
